import { Shield, Lock, Mail } from "lucide-react";
import type { TrustSeal } from "@/store/webinar/types";

interface TrustSealsProps {
  seals: TrustSeal[];
  enabled: boolean;
}

export function TrustSeals({ seals, enabled }: TrustSealsProps) {
  if (!enabled) return null;

  const activeSeals = seals.filter(seal => seal.enabled);
  if (activeSeals.length === 0) return null;

  const getIcon = (iconName: string) => {
    switch (iconName) {
      case 'Shield':
        return <Shield className="h-4 w-4" />;
      case 'Lock':
        return <Lock className="h-4 w-4" />;
      case 'Mail':
        return <Mail className="h-4 w-4" />;
      default:
        return <Shield className="h-4 w-4" />;
    }
  };

  return (
    <div className="flex items-center justify-center gap-4 flex-wrap text-xs text-muted-foreground">
      {activeSeals.map((seal) => (
        <div key={seal.id} className="flex items-center gap-1.5">
          {getIcon(seal.icon)}
          <span>{seal.label}</span>
        </div>
      ))}
    </div>
  );
}
